import { Component, OnInit } from '@angular/core';
import Big from 'big.js';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { InputUtils } from 'src/app/@core/utils/input-utils';
import { ExchangeRate } from 'src/app/models/exchange-rate';
import { PaymentMethod } from 'src/app/models/payment-method';
import { PaymentMethodMovement } from 'src/app/models/payment-method-movements-model';
import { PaymentMethodType } from 'src/app/models/payment-method-type';
import { ExchangeRateService } from 'src/app/services/exchange-rate.service';
import { PaymentTypesService } from 'src/app/services/payment-types.service';
import { ReclasificationRequest, ReclasificationRequestPayment } from 'src/app/models/request/reclasification-request-model';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { AuthService } from 'src/app/services/auth.service';
import { PaymentsService } from 'src/app/services/payments.service';
import { Payment } from 'src/app/models/payment';

@Component({
  selector: 'app-payment-methods-movement-modal',
  templateUrl: './payment-methods-movement-modal.component.html',
  styleUrls: ['./payment-methods-movement-modal.component.sass']
})
export class PaymentMethodsMovementModalComponent implements OnInit {

  private confirmAction: (value: boolean) => any = (value: boolean) => { };

  paymentTypes: PaymentMethod[] = new Array<PaymentMethod>();
  paymentMethods: PaymentMethodType[] = new Array<PaymentMethodType>();

  paymentMethodMovements: PaymentMethodMovement[] = new Array<PaymentMethodMovement>();
  paymentMethodDeduct: PaymentMethodType = new PaymentMethodType();
  paymentMethodIncrease: PaymentMethodType = new PaymentMethodType();
  paymentMethodIncreaseAmount: number = 0;

  userName: string = "";

  constructor(private bsModalRef: BsModalRef, private paymentTypesService: PaymentTypesService,
    private exchangeRateService: ExchangeRateService,
    private configurationService: ConfigurationService,
    private paymentService: PaymentsService
  ) { }

  async ngOnInit(): Promise<void> {
    this.paymentTypes = (await this.paymentTypesService.getPaymentsType().toPromise()).response.content;
    this.paymentMethods = (await this.paymentTypesService.getPaymentMethods().toPromise()).response.content;
  }

  cancel() {
    this.bsModalRef.hide();
  }

  onlyNumbers(event: any): boolean {
    return InputUtils.onlyNumbers(event);
  }

  customSearch(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item['name'].toLocaleLowerCase().indexOf(term) > -1 || item['code'].toString().indexOf(term) > -1;
  }

  async add() {
    let paymentMethodMovement: PaymentMethodMovement = new PaymentMethodMovement();
    paymentMethodMovement.paymentMethodDeduct = this.paymentMethodDeduct;
    paymentMethodMovement.paymentMethodIncrease = this.paymentMethodIncrease;
    paymentMethodMovement.paymentMethodIncreaseAmount = this.paymentMethodIncreaseAmount;
    paymentMethodMovement.paymentMethodDeductAmount = this.paymentMethodIncreaseAmount;

    let exchangeRate: ExchangeRate = await this.exchangeRateService.readLatestExchangeRate();

    if (paymentMethodMovement.paymentMethodDeduct.currency == "HNL" && paymentMethodMovement.paymentMethodIncrease.currency == "USD") {
      paymentMethodMovement.paymentMethodDeductAmount = Number(new Big(paymentMethodMovement.paymentMethodIncreaseAmount * exchangeRate.rate).round(2));
    }

    if (paymentMethodMovement.paymentMethodDeduct.currency == "USD" && paymentMethodMovement.paymentMethodIncrease.currency == "HNL") {
      paymentMethodMovement.paymentMethodDeductAmount = Number(new Big(paymentMethodMovement.paymentMethodIncreaseAmount / exchangeRate.rate).round(2));
    }

    this.paymentMethodMovements.push(paymentMethodMovement);

    this.paymentMethodDeduct = new PaymentMethodType();
    this.paymentMethodIncrease = new PaymentMethodType();
    this.paymentMethodIncreaseAmount = 0;
  }

  delete(i: number) {
    this.paymentMethodMovements.splice(i, 1);
  }

  async sendRequest() {
    let reclasificationRequest: ReclasificationRequest = new ReclasificationRequest();
    reclasificationRequest.branchCode = this.configurationService.readSelectedBranchAndSalesOrg().branch.code;
    reclasificationRequest.registerCode = this.configurationService.readRegister().code;
    reclasificationRequest.salesOrg = this.configurationService.readSelectedBranchAndSalesOrg().salesOrg.code;
    reclasificationRequest.username = this.userName;

    reclasificationRequest.paymentList = new Array<ReclasificationRequestPayment>();

    this.paymentMethodMovements.forEach(x => {
      let reclasificationRequestPayment: ReclasificationRequestPayment = new ReclasificationRequestPayment();
      //Esta la logica al revez por que asi la entiende mejor el negocio
      reclasificationRequestPayment.sourcePaymentMethod = x.paymentMethodIncrease.code;
      reclasificationRequestPayment.sourceCurrency = x.paymentMethodIncrease.currency;
      reclasificationRequestPayment.sourceAmount = x.paymentMethodIncreaseAmount;
      reclasificationRequestPayment.destinationPaymentMethod = x.paymentMethodDeduct.code;
      reclasificationRequestPayment.destinationCurrency = x.paymentMethodDeduct.currency;
      reclasificationRequestPayment.destinationAmount = x.paymentMethodDeductAmount;

      reclasificationRequest.paymentList.push(reclasificationRequestPayment);
    });

    let response: Payment[] = (await this.paymentService.reclasify(reclasificationRequest).toPromise()).response;

    this.confirmAction(true);
    this.bsModalRef.hide();
  }
}